import { default as Vuex, Module, ActionContext } from "vuex";
import * as Models from "@gigalot/data-models";
import Uploadable, { UploadableScanningResult } from "@/models/uploadable";
import { getHhMmSs, getYyyyMmDd } from "@/helpers/date-time";
import { geolocation } from "@/helpers/geolocation";

class GroupVaccinationState {
  batchNumber?: string
  batchQuantity?: number
  notes?: string
  appliedVaccination?: Models.AppliedVaccination
  kraalId?: string
  averageMass?: number
}

export default new (class GroupVaccination implements Module<GroupVaccinationState, any> {
  namespaced = true;
  state: GroupVaccinationState = new GroupVaccinationState();
  mutations = {
    /*
    mutation(state: State, payload: any) {
      //no async calls
      state.data = payload;
    }
    */
    batchNumber(state: GroupVaccinationState, batchNumber?: string) {
      state.batchNumber = batchNumber;
    },
    batchQuantity(state: GroupVaccinationState, batchQuantity?: number) {
      state.batchQuantity = batchQuantity;
    },
    notes(state: GroupVaccinationState, notes?: string) {
      state.notes = notes;
    },
    appliedVaccination(state: GroupVaccinationState, appliedVaccination?: Models.AppliedVaccination) {
      state.appliedVaccination = appliedVaccination;
      console.log("appliedVaccination:", JSON.stringify(appliedVaccination))
    },
    kraalId(state: GroupVaccinationState, kraalId?: string) {
      state.kraalId = kraalId;
    },
    averageMass(state: GroupVaccinationState, averageMass?: number) {
      state.averageMass = averageMass;
    },
  };
  actions = {
    /*
    action(context: ActionContext<State, any>) {
      //async calls allowed, action can also be async
      //context.state, context.rootState, context.dispatch, context.commit
    }
    */
    async save(context: ActionContext<GroupVaccinationState, any>) {
      if (!context.state.batchNumber) {
        throw Error("No batch reference entered");
      }
      if (context.state.batchQuantity === undefined) {
        throw Error("No quantity entered");
      } else if (context.state.batchQuantity <= 0 || isNaN(context.state.batchQuantity)) {
        throw Error("Invalid batch quantity");
      }
      if (!context.state.appliedVaccination) {
        throw Error("No vaccination selected");
      }
      if (context.state.kraalId) {
        const kraalIds: string[] = await context.dispatch("data/getKraalIds", undefined, { root: true });
        if (kraalIds.find((kraalId) => kraalId === context.state.kraalId) === undefined) {
          throw Error("Invalid kraal");
        }
      }
      let metadata: Models.UpstreamMetadata = context.rootGetters["upload/getUpstreamMetadata"]();
      let groupVaccination: UploadableScanningResult = Object.assign(new Models.ScanningResult("group-vaccination", Date.now(), metadata), new Uploadable());
      groupVaccination.tags = context.rootState.scan.tags;

      const numTags = groupVaccination.tags.length;
      if (context.state.batchQuantity < numTags) {
        throw Error("Quantity can not be lower than number of tags scanned.");
      }
      groupVaccination.batchQuantity = "" + context.state.batchQuantity;

      if (!context.state.batchNumber) {
        context.commit("batchNumber", `${getYyyyMmDd(new Date(groupVaccination.time)).slice(2)}${getHhMmSs(new Date(groupVaccination.time))}`);
      }

      //try get geolocation
      try {
        const p = await geolocation({ enableHighAccuracy: false, maximumAge: 0, timeout: 15 * 1000 });
        groupVaccination.gpsLat = p.coords.latitude.toString();
        groupVaccination.gpsLon = p.coords.longitude.toString();
      } catch (err) {
        console.error("Could not get geolocation: ", err);
      }

      groupVaccination.batchNumber = context.state.batchNumber || "";

      groupVaccination.notes = context.state.notes;

      groupVaccination.vaccination = context.state.appliedVaccination
      groupVaccination.kraalId = context.state.kraalId || "";
      groupVaccination.averageMass = context.state.averageMass;

      groupVaccination.generateAutoBatchNumber();
      await context.dispatch("data/addGroupVaccination", groupVaccination, { root: true });
      context.commit("upload/numYetToUpload", "increment", { root: true });
      //throw Error("Some error here blah blah"); //uncomment this line to test Save popup displaying error
      try {
        context.dispatch("upload/upload", undefined, { root: true });
      } catch (e) {
        //silent failure is fine here, upload will likely fail here anyway if the user is still on the scanner's wifi
      }
    }
  };
  getters = {
    /*
    getter(state: State, getters: any, rootState: any, rootGetters: any) {
      //return a function if you want the getter to receive input parameters
    }
    */
  };
})();
